import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { PanelLayout } from "@/interactors/PanelLayout";

export const RouteComponent = () => {
  return (
    <PanelLayout>
      <Outlet />
    </PanelLayout>
  );
};

export const Route = createFileRoute("/_authed/instructor")({
  component: RouteComponent,
  beforeLoad: ({ context }) => {
    if (
      (context.userType && context.userType === "STUDENT") ||
      (context.userRole && context.userRole !== "INSTRUCTOR")
    ) {
      throw redirect({
        to: "/",
        search: {
          redirect: location.href.includes("/logout")
            ? undefined
            : location.href,
        },
      });
    }
  },
});
